import get from 'lodash/get';
import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { renderTextField } from '../../assets/formComponent';
import { validateEmail } from '../../assets/util';
import { forgotPasswordRequest } from '../../actions/auth';
import { swal, close } from 'react-redux-sweetalert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Firebase is loaded on demand — see `assets/firebase.js`. This component
// already lives in a lazy route chunk, but a static `firebase/auth` import here
// still risks webpack hoisting the SDK back into a shared/vendor chunk, so it
// uses the same accessor as every other call site.
import { loadFirebaseAuth } from '../../assets/firebase';

class ForgotPasswordForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reqForgotPassword: null,
            reqForgotPasswordErr: null,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.reqForgotPassword === null && this.state.reqForgotPassword === true) {
            this.props.swal({
                title: '',
                type: 'success',
                text: 'Reset password email is sent. Please check your email.',
                onConfirm: () => { this.props.close(); },
                customClass: 'bt-dialog-box',
            });
        } else if (prevState.reqForgotPassword === null && this.state.reqForgotPassword === false) {
            this.props.swal({
                title: '',
                type: 'error',
                text: this.state.reqForgotPasswordErr,
                onConfirm: () => { this.props.close(); },
                customClass: 'bt-dialog-box',
            });
        }
    }

    onSubmit(values) {
        let errObj = { _error: "Submit failed" };
        let error = false;

        if (!values.email) {
            errObj.email = "Email is required.";
            error = true;
        } else if (!validateEmail(values.email)) {
            errObj.email = "Email is invalid.";
            error = true;
        }

        if (error) {
            throw new SubmissionError(errObj);
        } else {
            // var actionCodeSettings = {
            //     url: 'https://thebeautrium.com/reset-password',
            //     iOS: {
            //         bundleId: 'com.beautytalk.beautrium'
            //     },
            //     android: {
            //         packageName: 'com.beautytalk.beautrium',
            //         installApp: true,
            //         minimumVersion: '12'
            //     },
            //     handleCodeInApp: true
            // };
            // Not awaited: redux-form's submit handler stays synchronous so a
            // `SubmissionError` above is still thrown synchronously.
            // `sendResetEmail` never rejects.
            this.sendResetEmail(values.email);
            // this.props.forgotPasswordRequest(values.email);
        }
    }

    /**
     * Ask Firebase to send a password-reset email, loading the Firebase chunk
     * on demand.
     *
     * A `FirebaseUnavailableError` is stored in `reqForgotPasswordErr` just like
     * a Firebase error would be; `render` translates `ERROR.AUTH.<code>`, and
     * `auth/module-load-failed` has an entry in `lang/err_lang.js`, so the user
     * gets a real message rather than a form that appears to do nothing.
     *
     * @param {string} email - Address to send the reset link to.
     * @returns {Promise<void>} Never rejects; failures land in component state.
     */
    async sendResetEmail(email) {
        try {
            const { auth, authApi } = await loadFirebaseAuth();
            await authApi.sendPasswordResetEmail(auth, email);
            this.setState({
                reqForgotPassword: true,
                reqForgotPasswordErr: null,
            });
        } catch (err) {
            this.setState({
                reqForgotPassword: false,
                reqForgotPasswordErr: err,
            });
        }
    }

    render() {
        const { handleSubmit, translate } = this.props;
        const { reqForgotPasswordErr } = this.state;
        return (
            <div id="forgot_password" className="bt-popup-backdrop">
                <div className="bt-popup bt-popup-forgot">
                    <div className="container" onClick={(e) => e.stopPropagation()}>
                        <label className="btn-close" onClick={this.props.closePopup}><FontAwesomeIcon icon={["fal", "times"]} style={{ height: "16px", width: "16px" }} /></label>
                        <span className="header mb-2">Forgot your password?</span>
                        {reqForgotPasswordErr && <div className="err-alert form-group row px-0 mx-auto">
                            <div className="alert alert-danger col-12" role="alert">
                                {translate(`ERROR.AUTH.${get(reqForgotPasswordErr, 'code', '')}`, reqForgotPasswordErr.message, { showMissingTranslationMsg: reqForgotPasswordErr.message })}
                            </div>
                        </div>}
                        <form className="forgetpassword-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <Field component={renderTextField} name="email" label="Your Email" type="text" placeholder="youremail@email.com" className="w-100 mt-2 mb-0" />
                            {/* <div className="form-group">
                                <label>Please type in your email address. We will send you a link for resetting password.</label>
                                <input className="form-control" type="text" placeholder="Email Address."></input>
                            </div> */}
                            <button type="submit" className="btn btn-black">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        // reqForgotPassword: state.auth.reqForgotPassword,
        // reqForgotPasswordErr: state.auth.reqForgotPasswordErr,
        translate: getTranslate(state.locale),
    }
}
export default reduxForm({
    form: 'reqForgotPasswordForm'
})(connect(mapStateToProps, { forgotPasswordRequest, swal, close })(ForgotPasswordForm));